import PageWrapper from "app/components/page-wrapper/page-wrapper";
import { useTheme } from "app/shared";
import { FC } from "react";
import { useParams } from "react-router-dom";
import {
  useFindByIdQuery,
  useGetReferralStatisticsQuery,
} from "store/api/new.api";
import { useAccount } from "wagmi";
import FullScreenLoader from "../loader/FullScreenLoader";
import CommissionTiers from "./CommissionTiers";
import Funnel from "./Funnel";
import styles from "./RefStatisticsById.module.scss";

const RefStatisticsById: FC = () => {
  const { idoId } = useParams<{ idoId: string }>();
  const { address } = useAccount();
  const { theme } = useTheme();

  const {
    data: stats,
    error: statsError,
    isLoading: statsIsLoading,
  } = useGetReferralStatisticsQuery({ idoId, address });

  const { data: ido, isLoading: idoLoading } = useFindByIdQuery(idoId);

  if (statsIsLoading || idoLoading) {
    return <FullScreenLoader isLoading={statsIsLoading} />;
  }

  const statistics = stats?.[0] || {
    referralPercent: 0,
    totalApplications: 0,
    claims: [],
    countClaimedZero: 0,
    countClaimedNonZero: 0,
    totalClaimed: 0,
    income: 0,
    averageClaimed: 0,
  };

  const claimsWithRewards = statistics.claims.map((claim: any) => ({
    ...claim,
    reward: claim.claimedValue * (statistics.referralPercent / 100),
  }));

  return (
    <PageWrapper>
      <div
        className={`${styles.main} ${theme === "dark" ? styles.darkTheme : ""}`}
      >
        <div className={styles.content}>
          <div className={styles.wrapper}>
            <h1 className={styles.title}>
              Your {ido.title} Referral Performance Dashboard
            </h1>
            <p>Track traffic, purchases & earnings from your custom link</p>
            <div className={styles.funnelContainer}>
              <CommissionTiers totalClaimed={statistics.totalClaimed} />
              <div
                className={`${styles.titleWrapper} ${
                  theme === "dark" ? styles.darkTheme : ""
                }`}
              >
                <h3>Referral Funnel Breakdown</h3>
                <Funnel statistics={statistics} />
              </div>
            </div>

            {statistics.claims.length > 0 && (
              <>
                <div style={{ marginTop: "20px" }}>
                  <p>
                    💡 Your final referral commission will be calculated after
                    the sale ends, based on total referred volume. See your
                    current tier above.
                  </p>
                </div>
                <div className={styles.claimsSection}>
                  <h2 className={styles.subtitle}>Detailed Claims</h2>
                  <div
                    className={`${styles.claimsTable} ${
                      theme === "dark" ? styles.darkTheme : ""
                    }`}
                  >
                    <div className={styles.tableHeader}>
                      <div>Buyer Address</div>
                      <div>Purchase Amount (USD)</div>
                      {/* <div>Your Income</div> */}
                    </div>
                    {claimsWithRewards.map((claim: any, index: number) => (
                      <div key={index} className={styles.tableRow}>
                        <div>{claim.address}</div>
                        <div>{claim.claimedValue.toFixed(2)} USD</div>
                        {/* <div>{claim.reward.toFixed(2)} USD</div> */}
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default RefStatisticsById;
